import { render, staticRenderFns } from "./Favorite.component.vue?vue&type=template&id=36b5c856&scoped=true"
import script from "./Favorite.component.vue?vue&type=script&lang=js"
export * from "./Favorite.component.vue?vue&type=script&lang=js"
import style0 from "./Favorite.component.vue?vue&type=style&index=0&id=36b5c856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5c856",
  null
  
)

export default component.exports